<template>
  <div style="margin-top: -12px">
    <v-container fluid>
      <v-card flat class="disable-scrollbars" color="transparent">
        <v-row style="min-height: 50px">
          <v-col class="text-justify" sm="12" md="6" lg="4" xs="12">
            <v-card elevation="0" class="mt-n3" min-width="350">
              <v-card-text>
                <v-list-item three-line>
                  <v-list-item-content>
                    <div
                      class="overline mb-4 font-weight-bold blue-grey--text"
                      style="font-size: 11px !important;"
                    >
                      Pin
                    </div>
<!--                    <v-list-item-subtitle class="punk-border"-->
<!--                      >Parabéns! A sua carteira digital já se encontra configurada.</v-list-item-subtitle-->
<!--                    >-->
                    <v-list-item-subtitle class="punk-border"
                      >Crie, Actualize o seu PIN de transações  em definições</v-list-item-subtitle
                    >
                  </v-list-item-content>

                  <v-list-item-avatar tile size="120" color="transparent" class="d-none d-sm-flex">
                    <v-progress-circular
                      :rotate="-90"
                      :size="100"
                      :width="15"
                      :value="100"
                      color="#1976d2c4"
                    >

                    </v-progress-circular>
                  </v-list-item-avatar>
                </v-list-item>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col class=" text-left" sm="12" md="6" lg="8" xs="12">
            <v-card elevation="0" class="mt-n3" min-height="183">
              <v-card-text>
                <v-list-item three-line class="mt-n2">
                  <v-list-item-content>
                    <div
                      class="overline mb-4 font-weight-bold blue-grey--text"
                      style="font-size: 11px !important;"
                    >
                      O que pode fazer
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card-text>
              <v-card-text class="mt-n12">
                <div class="text-left">
                  <div
                    style="width: 205px; height: 50px; display: inline-table"
                    class=""
                  >
                    <div
                      style="width: 50px; height:50px; display: inline-table; padding: 9px; background-color: #3cb3718a"
                      class="circular"
                    >
                      <v-icon class="text-center ml-1 mt-1 mr-1"
                        >mdi-wallet-outline</v-icon
                      >
                    </div>
                    <div
                      style="width: 130px; margin-top: -47px; margin-left: 59px;; padding: 2px;"
                    >
                      <div>
                        Wallet
                      </div>
                      <div>
                        Pagar e transferir
                      </div>
                    </div>
                  </div>

                  <div
                    style="width: 235px; height: 50px; display: inline-table"
                    class=""
                  >
                    <div
                      style="width: 50px; height:50px; display: inline-table; padding: 9px ; background-color: #0099ff7d"
                      class="circular"
                    >
                      <v-icon class="text-center ml-1 mt-1 mr-1"
                        >mdi-bank-outline</v-icon
                      >
                    </div>
                    <div
                      style="width: 180px; margin-top: -47px; margin-left: 59px;; padding: 2px;"
                    >
                      <div>
                        MCX Express
                      </div>
                      <div>
                        Pagar serviços
                      </div>
                    </div>
                  </div>

                  <div
                    style="width: 205px; height: 50px; display: inline-table"
                    class=""
                  >
                    <div
                      style="width: 50px; height:50px; display: inline-table; padding: 9px; background-color: #9c007e57"
                      class="circular"
                    >
                      <v-icon class="text-center ml-1 mt-1 mr-1"
                        >mdi-check</v-icon
                      >
                    </div>
                    <div
                      style="width: 130px; margin-top: -47px; margin-left: 59px;; padding: 2px;"
                    >
                      <div>
                        Online
                      </div>
                      <div>
                        Comprar na internet
                      </div>
                    </div>
                  </div>
                  <!--                                        <div style="width: 280px; height: 50px; display: inline-table" class="">-->
                  <!--                                            <div style="width: 50px; height:50px; display: inline-table; padding: 9px; background-color: #d28d1996" class="circular">-->
                  <!--                                                <v-icon class="text-center ml-1 mt-1 mr-1">mdi-wallet-outline</v-icon>-->
                  <!--                                            </div>-->
                  <!--                                            <div style="width: 190px; margin-top: -47px; margin-left: 59px;; padding: 2px;">-->
                  <!--                                                <div>-->
                  <!--                                                    Wallet-->
                  <!--                                                </div>-->
                  <!--                                                <div>-->
                  <!--                                                    Transferência entre wallet-->
                  <!--                                                </div>-->
                  <!--                                            </div>-->
                  <!--                                        </div>-->
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PerfiComplete"
};
</script>

<style scoped>
.circular {
  border-radius: 148px;
}
.punk-border {
  width: 10px;
  border-left: 10px solid rgba(25, 118, 210, 0.77);
  padding: 5px;
  margin-right: 5px;
}
</style>
